import { Box, Typography } from '@mui/material';
import pluralize from 'pluralize';
import { useMemo } from 'react';

import { RewardTransaction, RewardTransactionAction } from '@jebel/constants';

import { useRelativeDate } from 'shared/hooks';

export function RewardTransactionListItem({ transaction }: { transaction: RewardTransaction }) {
  const creationDate = useMemo(() => {
    return new Date(transaction.creationDate);
  }, [transaction.creationDate]);

  const relativeCreationDate = useRelativeDate(creationDate);

  const description = useMemo(() => {
    if (transaction.action === RewardTransactionAction.AdViewed) {
      return 'Ad viewed';
    }

    if (transaction.action === RewardTransactionAction.BusinessClaimed) {
      return 'Business claimed';
    }

    if (transaction.action === RewardTransactionAction.CommentCreated) {
      return 'Comment created';
    }

    if (transaction.action === RewardTransactionAction.DiscountRedeemed) {
      return 'Discount redeemed';
    }

    if (transaction.action === RewardTransactionAction.PostCreated) {
      return 'Post created';
    }

    if (transaction.action === RewardTransactionAction.PostLiked) {
      return 'Post liked';
    }

    return transaction.action;
  }, [transaction.action]);

  const pointsDescription = useMemo(() => {
    if (transaction.points === 0) {
      return null;
    }

    const signed = transaction.points > 0 ? '+' : '-';
    const points = Math.abs(transaction.points);
    const suffix = pluralize('point', points);

    return `${signed}${points} ${suffix}`;
  }, [transaction.points]);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" padding="0.5rem 0">
      <Box>
        <Typography fontWeight="bold">{description}</Typography>

        <Typography variant="body2" color="textSecondary">
          {relativeCreationDate}
        </Typography>
      </Box>

      <Typography>{pointsDescription}</Typography>
    </Box>
  );
}
